import moment from 'moment';

export const checkIfAppointmentDurationIsInOneDay = (StartDate, Duration) => {
    let EndDate = moment(StartDate).add(Duration, 'minutes').format();
    EndDate = new Date(EndDate);
    if(StartDate.getDay() === EndDate.getDay()) return true;
    return false;
}